// Old Dominion University's bachelor's majors (#2739). Read on 2026-10-01
// from ODU's official Academic Catalog, 2026-2027 Edition (catalog.odu.edu),
// Programs, Degrees and Majors: every undergraduate program the catalog types
// "Bachelor's", grouped by the college or school the catalog files it under.
// ODU names many degree programs "X with a Major in Y"; the catalog lists each
// as its own bachelor's program, so each is listed here, with the degree as
// the catalog writes it. Degree-completion and post-licensure programs are
// kept because the catalog lists them as bachelor's programs. Minors,
// certificates, graduate programs and the Naval Science and Military
// Leadership ROTC programs (not degrees) are left out. Names are the
// catalog's, with "and" for its ampersands.
const majors = {
    "slug": "old-dominion-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's program in ODU's official 2026-2027 Catalog, by college or school. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Letters",
            "source": {
                "label": "ODU Catalog 2026-2027, College of Arts and Letters",
                "url": "https://catalog.odu.edu/undergraduate/arts-letters/"
            },
            "majors": [
                {
                    "name": "Art with a Major in Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art with a Major in Visual Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "BS"
                },
                {
                    "name": "Communication with a Major in Cinema and TV Production",
                    "degree": "BA"
                },
                {
                    "name": "Communication with a Major in Cinema and TV Production",
                    "degree": "BS"
                },
                {
                    "name": "Communication with a Major in Cinema Screenwriting and Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication with a Major in Cinema Screenwriting and Studies",
                    "degree": "BS"
                },
                {
                    "name": "Communication with a Major in Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Communication with a Major in Media Studies",
                    "degree": "BS"
                },
                {
                    "name": "Communication with a Major in Organizational and Interpersonal Communication",
                    "degree": "BA"
                },
                {
                    "name": "Communication with a Major in Organizational and Interpersonal Communication",
                    "degree": "BS"
                },
                {
                    "name": "Communication with a Major in Professional Communication",
                    "degree": "BS"
                },
                {
                    "name": "Communication with a Major in Strategic Communication and Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Communication with a Major in Strategic Communication and Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BA"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice with a Major in Cybercriminology",
                    "degree": "BS"
                },
                {
                    "name": "English with a Major in Applied Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "English with a Major in Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "English with a Major in Literature",
                    "degree": "BA"
                },
                {
                    "name": "English with a Major in Secondary English Education (6-12)",
                    "degree": "BA"
                },
                {
                    "name": "English with a Major in Technical and Professional Writing",
                    "degree": "BA"
                },
                {
                    "name": "Fine Arts with a Major in 3D Media and Material Studies",
                    "degree": "BFA"
                },
                {
                    "name": "Fine Arts with a Major in Art Education for Museums and Cultural Institutions",
                    "degree": "BFA"
                },
                {
                    "name": "Fine Arts with a Major in Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Fine Arts with a Major in Painting and Drawing",
                    "degree": "BFA"
                },
                {
                    "name": "Fine Arts with a Major in Photography and Print Media",
                    "degree": "BFA"
                },
                {
                    "name": "Fine Arts with a Major in PreK-12 Art Education",
                    "degree": "BFA"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geography with a Major in Environment and Resources",
                    "degree": "BA"
                },
                {
                    "name": "Geography with a Major in Environment and Resources",
                    "degree": "BS"
                },
                {
                    "name": "Geography with a Major in Geographic Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Geography with a Major in Urban Planning and Emergency/Hazards Management",
                    "degree": "BA"
                },
                {
                    "name": "Geography with a Major in Urban Planning and Emergency/Hazards Management",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History with a Major in Secondary History/Social Sciences Education (6-12)",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies with a Major in Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies with a Major in Game Studies and Design-Design and Criticism",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies with a Major in Game Studies and Design-Development and Criticism",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies with a Major in General Studies",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies with a Major in Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies with a Major in Professional Writing",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies with a Major in Supply Chain and Maritime Logistics",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies with a Major in Women's and Gender Studies",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Studies with a Major in Women's and Gender Studies",
                    "degree": "BS"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music with a Major in Composition",
                    "degree": "BM"
                },
                {
                    "name": "Music with a Major in Jazz Studies",
                    "degree": "BM"
                },
                {
                    "name": "Music with a Major in Performance-Orchestral Instruments",
                    "degree": "BM"
                },
                {
                    "name": "Music with a Major in PreK-12 Music Education-Instrumental",
                    "degree": "BM"
                },
                {
                    "name": "Music with a Major in PreK-12 Music Education-Voice",
                    "degree": "BM"
                },
                {
                    "name": "Music with an Emphasis in Sound Recording Technology",
                    "degree": "BM"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy with a Major in Political and Legal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy with a Major in Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Political Science with a Major in Analytics, Institutions, and Public Policy",
                    "degree": "BS"
                },
                {
                    "name": "Political Science with a Major in International Affairs and Global Politics",
                    "degree": "BA"
                },
                {
                    "name": "Political Science with a Major in International Affairs and Global Politics",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Sociology with a Major in Social Welfare",
                    "degree": "BA"
                },
                {
                    "name": "Sociology with a Major in Social Welfare",
                    "degree": "BS"
                },
                {
                    "name": "Theatre and Dance with a Major in Cinema Production",
                    "degree": "BA"
                },
                {
                    "name": "Theatre and Dance with a Major in Dance",
                    "degree": "BA"
                },
                {
                    "name": "Theatre and Dance with a Major in Design Technology",
                    "degree": "BA"
                },
                {
                    "name": "Theatre and Dance with a Major in Performance",
                    "degree": "BA"
                },
                {
                    "name": "Theatre and Dance with a Major in PreK-12 Dance Education",
                    "degree": "BA"
                },
                {
                    "name": "Theatre and Dance with a Major in PreK-12 Theatre Education",
                    "degree": "BA"
                },
                {
                    "name": "Theatre and Dance with a Major in Theatre",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures with a Major in French",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures with a Major in German",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures with a Major in Japanese",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures with a Major in PreK-12 French Education",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures with a Major in PreK-12 German Education",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures with a Major in PreK-12 Spanish Education",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures with a Major in Spanish",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures with a Major in World Cultural Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Strome College of Business",
            "source": {
                "label": "ODU Catalog 2026-2027, Strome College of Business",
                "url": "https://catalog.odu.edu/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Economics",
                    "degree": "BSBA"
                },
                {
                    "name": "Financial Management with a Major in Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "Financial Management with a Major in Personal Financial Planning",
                    "degree": "BSBA"
                },
                {
                    "name": "Financial Management with a Major in Real Estate",
                    "degree": "BSBA"
                },
                {
                    "name": "Financial Management with a Major in Risk Management and Insurance",
                    "degree": "BSBA"
                },
                {
                    "name": "Information Systems and Technology",
                    "degree": "BSBA"
                },
                {
                    "name": "Information Systems and Technology with a Major in Business Analytics",
                    "degree": "BSBA"
                },
                {
                    "name": "Information Systems and Technology with a Major in Business Analytics and Intelligence",
                    "degree": "BSBA"
                },
                {
                    "name": "Information Systems and Technology with a Major in Database",
                    "degree": "BSBA"
                },
                {
                    "name": "Information Systems and Technology with a Major in Network Engineering",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Management with a Major in Entrepreneurship",
                    "degree": "BSBA"
                },
                {
                    "name": "Management with a Major in Human Resource Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Management with a Major in International Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing Management with a Major in Marketing Insights and Innovation",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing with a Major in Digital Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Marketing with a Major in Professional Sales",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "Darden College of Education and Professional Studies",
            "source": {
                "label": "ODU Catalog 2026-2027, Darden College of Education and Professional Studies",
                "url": "https://catalog.odu.edu/undergraduate/education/"
            },
            "majors": [
                {
                    "name": "Career and Technical Education with a Major in Marketing Education",
                    "degree": "BS"
                },
                {
                    "name": "Career and Technical Education with a Major in Technology Education",
                    "degree": "BS"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS"
                },
                {
                    "name": "Human Services",
                    "degree": "BS"
                },
                {
                    "name": "Occupational and Technical Studies with a Major in Fashion Merchandising",
                    "degree": "BS"
                },
                {
                    "name": "Occupational and Technical Studies with a Major in Industrial Technology",
                    "degree": "BS"
                },
                {
                    "name": "Occupational and Technical Studies with a Major in Training Specialist",
                    "degree": "BS"
                },
                {
                    "name": "Park, Recreation and Tourism Studies with a Major in Park and Recreation Management",
                    "degree": "BS"
                },
                {
                    "name": "Park, Recreation and Tourism Studies with a Major in Tourism and Hospitality Management",
                    "degree": "BS"
                },
                {
                    "name": "Physical Education with a Major in Coaching and Physical Activity Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Physical Education with a Major in PreK-12 Health and Physical Education",
                    "degree": "BS"
                },
                {
                    "name": "Special Education with a Major in Early Intervention/Early Childhood Special Education (Birth-5)",
                    "degree": "BS"
                },
                {
                    "name": "Special Education with a Major in Special Education Adapted Curriculum K-12",
                    "degree": "BS"
                },
                {
                    "name": "Special Education with a Major in Special Education General Curriculum K-12",
                    "degree": "BS"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Frank Batten College of Engineering and Technology",
            "source": {
                "label": "ODU Catalog 2026-2027, Frank Batten College of Engineering and Technology",
                "url": "https://catalog.odu.edu/undergraduate/engineering-technology/"
            },
            "majors": [
                {
                    "name": "Civil Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Computer Engineering with a Major in Modeling and Simulation Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE"
                },
                {
                    "name": "Engineering Technology with a Major in Civil Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Engineering Technology with a Major in Electrical Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Engineering Technology with a Major in Manufacturing Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Engineering Technology with a Major in Mechanical Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "Ellmer College of Health Sciences",
            "source": {
                "label": "ODU Catalog 2026-2027, Ellmer College of Health Sciences",
                "url": "https://catalog.odu.edu/undergraduate/health-sciences/"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "BSDH"
                },
                {
                    "name": "Dental Hygiene with a Major in Dental Hygiene Post-Licensure",
                    "degree": "BSDH"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences with a Major in Pre-Clinical Studies",
                    "degree": "BSHS"
                },
                {
                    "name": "Health Sciences with a Major in Recreational Therapy",
                    "degree": "BSHS"
                },
                {
                    "name": "Medical Laboratory Science",
                    "degree": "BSMLS"
                },
                {
                    "name": "Medical Laboratory Science with a Major in Medical Laboratory Science Degree Completion",
                    "degree": "BSMLS"
                },
                {
                    "name": "Nuclear Medicine Technology",
                    "degree": "BSNMT"
                },
                {
                    "name": "Speech-Language Pathology and Audiology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Ellmer School of Nursing",
            "source": {
                "label": "ODU Catalog 2026-2027, Ellmer School of Nursing",
                "url": "https://catalog.odu.edu/undergraduate/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing with a Major in Nursing Concurrent",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing with a Major in Nursing Post-Licensure",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing with a Major in Nursing Pre-Licensure",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Joint School of Public Health",
            "source": {
                "label": "ODU Catalog 2026-2027, Joint School of Public Health",
                "url": "https://catalog.odu.edu/undergraduate/joint-school-public-health/"
            },
            "majors": [
                {
                    "name": "Environmental Health",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BSPH"
                },
                {
                    "name": "Public Health with a Major in Health Services Administration",
                    "degree": "BSPH"
                },
                {
                    "name": "Public Health with a Major in Health Services Administration (Professional)",
                    "degree": "BSPH"
                }
            ]
        },
        {
            "name": "College of Sciences",
            "source": {
                "label": "ODU Catalog 2026-2027, College of Sciences",
                "url": "https://catalog.odu.edu/undergraduate/sciences/"
            },
            "majors": [
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry with a Major in Biochemistry-Research",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry with a Major in Secondary Chemistry Education (6-12)",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology with a Major in Biology-One Health",
                    "degree": "BS"
                },
                {
                    "name": "Biology with a Major in Biomedical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biology with a Major in Biomedical Sciences-Pre Health",
                    "degree": "BS"
                },
                {
                    "name": "Biology with a Major in Marine Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology with a Major in Secondary Biology Education (6-12)",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry with a Major in Chemical Forensic Science",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry with a Major in Chemistry Pre-Med",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry with a Major in Research",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry with a Major in Secondary Chemistry Education (6-12)",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BSCS"
                },
                {
                    "name": "Computer Science with a Major in Secondary Computer Science Education (6-12)",
                    "degree": "BSCS"
                },
                {
                    "name": "Mathematics with a Major in Actuarial Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics with a Major in Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics with a Major in Big Data Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics with a Major in Secondary Mathematics Education (6-12)",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics with a Major in Statistics/Biostatistics",
                    "degree": "BS"
                },
                {
                    "name": "Ocean and Earth Science with a Major in Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Ocean and Earth Science with a Major in Geology",
                    "degree": "BS"
                },
                {
                    "name": "Ocean and Earth Science with a Major in Marine Science Technology",
                    "degree": "BS"
                },
                {
                    "name": "Ocean and Earth Science with a Major in Middle School Science Education (6-8)",
                    "degree": "BS"
                },
                {
                    "name": "Ocean and Earth Science with a Major in Oceanography",
                    "degree": "BS"
                },
                {
                    "name": "Ocean and Earth Science with a Major in Secondary Earth Science Education (6-12)",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Physics with a Major in Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Physics with a Major in Physics and Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Physics with a Major in Physics and Master of Business Administration",
                    "degree": "BS-MBA"
                },
                {
                    "name": "Physics with a Major in Physics-Professional",
                    "degree": "BS"
                },
                {
                    "name": "Physics with a Major in Secondary Physics Education (6-12)",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Cybersecurity",
            "source": {
                "label": "ODU Catalog 2026-2027, School of Cybersecurity",
                "url": "https://catalog.odu.edu/undergraduate/cybersecurity/"
            },
            "majors": [
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity with a Major in Artificial Intelligence for Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity with a Major in Cyber Operations",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity with a Major in Cyber Risk Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Data Science",
            "source": {
                "label": "ODU Catalog 2026-2027, School of Data Science",
                "url": "https://catalog.odu.edu/undergraduate/data-science/"
            },
            "majors": [
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science with a Major in Data for a Human World",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
